// extracted by mini-css-extract-plugin
export default {"mainGalerija":"GalerySection_mainGalerija__8RhdO","containerImages":"GalerySection_containerImages__5MkkZ","image":"GalerySection_image__3CUZ5"};